module.exports = __webpack_public_path__ + "static/turtle-creek-house26-cf67eacb9d9d17b38b5ee6f0af931125.jpg";